// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--BJ56b","title":"dd31006766--title--G3wtf","desktop":"dd31006766--desktop--IHUUt","mobile":"dd31006766--mobile--Kyjvu"};